import auth from '@/middleware/modules/auth'

const ScheduleIndex = () => import(/* webpackChunkName: "_v-schedule" */ '@/views/scheduler/ScheduleIndex.vue')
const SchduleEdit = () => import(/* webpackChunkName: "_v-schedule" */ '@/views/scheduler/ScheduleEdit.vue')
const TabPlanner = () => import(/* webpackChunkName: "_v-schedule" */ '@/views/scheduler/tabs/TabPlanner.vue')
const TabScheduled = () => import(/* webpackChunkName: "_v-schedule" */ '@/views/scheduler/tabs/TabScheduled.vue')
const TabDraft = () => import(/* webpackChunkName: "_v-schedule" */ '@/views/scheduler/tabs/TabScheduled.vue')
const TabPast = () => import(/* webpackChunkName: "_v-schedule" */ '@/views/scheduler/tabs/TabScheduled.vue')

export default [
  {
    path: 'scheduler',
    name: 'scheduler',
    props: (route) => ({ querySearch: route.query.search }),
    component: ScheduleIndex,
    redirect: { name: 'scheduler-planner' },
    meta: {
      layout: 'app-layout',
      middleware: [auth],
    },
    children: [
      {
        props: (route) => ({ querySearch: route.query.search }),
        path: 'planner',
        name: 'scheduler-planner',
        component: TabPlanner,
        meta: {
          layout: 'app-layout',
          tab: 'scheduler-planner',
          middleware: [auth],
        },
      },
      {
        props: (route) => ({ querySearch: route.query.search }),
        path: 'scheduled',
        name: 'scheduler-scheduled',
        component: TabScheduled,
        meta: {
          layout: 'app-layout',
          tab: 'scheduler-scheduled',
          middleware: [auth],
        },
      },
      {
        props: (route) => ({ querySearch: route.query.search }),
        path: 'posted',
        name: 'scheduler-pastscheduled',
        component: TabPast,
        meta: {
          layout: 'app-layout',
          tab: 'scheduler-pastscheduled',
          middleware: [auth],
        },
      },
      {
        props: (route) => ({ querySearch: route.query.search }),
        path: 'draft',
        name: 'scheduler-draft',
        component: TabDraft,
        meta: {
          layout: 'app-layout',
          tab: 'scheduler-draft',
          middleware: [auth],
        },
      },
    ],
  },
  {
    path: 'schedule/new',
    name: 'schedule-new',
    component: SchduleEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['scheduler'],
    },
  },
  {
    path: 'schedule/:id(\\d+)/edit',
    name: 'schedule-edit',
    component: SchduleEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['scheduler'],
    },
  },
]
